import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import HeritagePage from "./pages/HeritagePage";
import HeritageTimelinePage from "./pages/HeritageTimelinePage";
import HeritageArchivePage from "./pages/HeritageArchivePage";
import TransitionPage from "./pages/TransitionPage";
import ContactPage from "./pages/ContactPage";

// Components
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ChatWidget } from "./components/ChatWidget";

export const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : "/api";

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-[#060B19] text-white" data-theme="dark">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage isLoaded={isLoaded} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/heritage" element={<HeritagePage />} />
          <Route path="/heritage/timeline" element={<HeritageTimelinePage />} />
          <Route path="/heritage/archive" element={<HeritageArchivePage />} />
          <Route path="/transition" element={<TransitionPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
        <ChatWidget />
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </Router>
  );
}

export default App;
